// @flow
import React, { Fragment, PureComponent } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { getPublicAssets } from 'utils/assetsUtils';
import CompetitionListRow from 'components/competition/CompetitionListRow';
import type { CompetitionListElementType } from 'types/Competition';
import Breadcrumb from 'components/fragments/Breadcrumb';
import { getCompetitionsByCategory } from 'utils/competitionsUtils';
import FooterArticle from 'components/newsletter/FooterArticle';
import Loading from 'components/fragments/Loading';
import type { ArticleType } from 'types/Article';
import type { Status } from 'types/Status';
import { STATUS_LOADING } from 'constants/statusConstants';
import { getMetaBySlug } from 'utils/seoUtils';

export type StateProps = {
  // $FlowFixMe
  competitions: Array<CompetitionListElementType>,
  articles: Array<ArticleType>,
  status: Status,
  title: string,
  ligue: string,
  ligue_id: number,
};

export type DispatchProps = {
  fetchCompetitions: (ligue_id: number) => void,
  fetchCompetitionsArticles: () => void
};

type Props = StateProps & DispatchProps;

class CompetitionList extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    competitions: [
      {
        division: 'Honneur et réserve honneur',
        slug: 'senior-honneur',
        recents: 0,
        age: '+18',
        sexe: 'M',
        famille: 'territoriale',
        first: {
          slug: 'union-sportive-acignolaise',
          title: 'Union Sportive Acignolaise',
          src: '/img/logo/club.jpeg'
        }
      },
      {
        division: 'Honneur et réserve honneur',
        slug: 'senior-honneur',
        recents: 5,
        age: '+18',
        sexe: 'F',
        famille: 'federale',
        first: {
          slug: 'union-sportive-acignolaise',
          title: 'Union Sportive Acignolaise',
          src: '/img/logo/club.jpeg'
        }
      }
    ]
  }; // En attendant de recevoir le bon appel

  componentDidMount() {
    if (parseInt(this.props.ligue_id, 10) > 0) {
      this.props.fetchCompetitions(this.props.ligue_id);
    }
    this.props.fetchCompetitionsArticles();
  }

  componentDidUpdate(prevProps:Props) {
    if (this.props.ligue_id !== prevProps.ligue_id && parseInt(this.props.ligue_id, 10) > 0) {
      this.props.fetchCompetitions(this.props.ligue_id);
    }
  }
  renderCompetitions = (): any => {
    const { ligue_id, status } = this.props;
    if (status === STATUS_LOADING) {
      return <Loading isWhite />;
    }

    const competitionsByCategory = getCompetitionsByCategory(this.props.competitions);
    return competitionsByCategory.map((competition, index) => (
      <CompetitionListRow
        key={index}
        title={competition.title}
        championships={competition.championships}
        ligue_id={ligue_id}
      />
    ));
  };

  render() {
    return (
      <Fragment>
        <section className="banner banner--big">
          <div
            className="banner__thumbnail img-blue-alt"
            style={{ backgroundImage: `url(${getPublicAssets('/img/banner/gerer-mon-club.jpg')})` }}
          />
          <div className="container">
            <Breadcrumb breadcrumbStyle="mt-3" isDark elements={[{ name: 'accueil', to: '/' }, 'Compétitions']} />
            <h1 className="ft-h2">Compétitions</h1>
            <p className="banner__desc">{`L'ensemble des compétitions au sein de la ${this.props.title}.`}</p>
          </div>
        </section>
        <div className="container">
          <div className="container">
            <div className="row mb-6 mb-md-7 mb-lg-8">
              <div className="col">
                <div className="box list-competition ">{this.renderCompetitions()}</div>
              </div>
            </div>
          </div>
          <FooterArticle articles={this.props.articles} slug={'competitions'} label={'Compétitions'} />
        </div>
      </Fragment>
    );
  }
}

export default withHelmet(CompetitionList)((Helmet, pageProps) => {
  const meta = getMetaBySlug(pageProps.location.pathname);
  return (
    <Helmet>
      <title>{meta.title(pageProps.ligue)}</title>
      <meta name={'description'} content={meta.description(pageProps.ligue)} />
      <link rel={'canonical'} href={window.location.href} />
      <meta property={'og:title'} content={meta.title(pageProps.ligue)} />
      <meta property={'og:description'} content={meta.description(pageProps.ligue)} />
      <meta property={'og:image'} content={getPublicAssets('/img/banner/gerer-mon-club.jpg')} />
    </Helmet>
  );
});
